export default __webpack_public_path__ + "static/media/notification.a83381f2f83b0fd6b3a05dfe1631b139.svg";